<template>
  <div class="BasicSystemSettings">
    <v-tabs vertical class="justify-right">
      <v-tab href="#DBConfig" class="justify-right">
        <v-icon> mdi-database </v-icon>
        <span v-if="$vuetify.breakpoint.smAndUp">
        تنظیمات پایگاه داده
        </span>
      </v-tab>
      <v-tab href="#LockConfig" class="justify-right">
        <v-icon> mdi-lock </v-icon>
        <span v-if="$vuetify.breakpoint.smAndUp">
        قفل و مجوزها
        </span>
      </v-tab>

      <v-tab-item value="DBConfig">
        <div class="pa-3">
          <db-settings :config="config"/>
        </div>
      </v-tab-item>

      <v-tab-item value="LockConfig">
        <div class="pa-3">
          <locks-and-permissions :config="config"/>
        </div>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import DbSettings from "./DbSettings.vue";
import LocksAndPermissions from "./LocksAndPermissions.vue";
export default {
  components: { DbSettings, LocksAndPermissions },
  props: { config: Object },
  data() {
    return {};
  },
};
</script>

<style>
.BasicSystemSettings .v-tabs-bar {
  border: 0.15rem solid #f2f2f2;
  padding: 0.5rem;
}
</style>